/* src/app/modules/notification/notification-list.component.css */
:host {
  --nl-brand: #e3fd64;
  --nl-brand-d: #4d7a00;
  --nl-text: #1a1d23;
  --nl-muted: #6b7280;
  --nl-border: #e5e7eb;
  --nl-surface: #ffffff;
  --nl-radius: 10px;
  --nl-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.nl-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.nl-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.nl-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.nl-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.nl-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.nl-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--nl-text);
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 10px;
}
.nl-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--nl-muted);
}
.nl-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: #dc2626;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.nl-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.nl-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.nl-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--nl-brand);
}
.nl-loading__dots {
  display: flex;
  gap: 8px;
}
.nl-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--nl-brand);
  opacity: 0.3;
  animation: nl-pulse 1.2s ease-in-out infinite;
}
.nl-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.nl-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes nl-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.nl-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--nl-muted);
}
.nl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 64px 24px;
  text-align: center;
}
.nl-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(227, 253, 100, 0.1);
}
.nl-empty__art mat-icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: var(--nl-brand);
}
.nl-empty__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--nl-text);
}
.nl-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--nl-muted);
}
.nl-bulk-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: var(--nl-surface);
  border: 1px solid var(--nl-border);
  border-radius: var(--nl-radius);
  box-shadow: var(--nl-shadow);
}
.nl-bulk-bar__label {
  font-size: 13.5px;
  color: var(--nl-text);
  font-weight: 500;
}
.nl-bulk-bar__actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.nl-btn-danger {
  color: #dc2626 !important;
  border-color: rgba(220, 38, 38, 0.3) !important;
}
.nl-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: var(--nl-surface);
  border: 1px solid var(--nl-border);
  border-radius: var(--nl-radius);
  box-shadow: var(--nl-shadow);
  overflow: hidden;
}
.nl-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 16px 16px 20px;
  border-bottom: 1px solid var(--nl-border);
  border-left: 3px solid transparent;
  transition: background 0.12s;
  position: relative;
}
.nl-item:last-child {
  border-bottom: none;
}
.nl-item:hover {
  background: #fafafa;
}
.nl-item--selected {
  background: rgba(227, 253, 100, 0.04);
}
.nl-item--unread {
  background: #fffdf5;
}
.nl-item--unread:hover {
  background: #fff9e6;
}
.nl-item--info {
  border-left-color: #3b82f6;
}
.nl-item--success {
  border-left-color: #16a34a;
}
.nl-item--warning {
  border-left-color: #f59e0b;
}
.nl-item--error {
  border-left-color: #dc2626;
}
.nl-item__check {
  flex-shrink: 0;
  margin-top: 2px;
}
.nl-item__icon {
  flex-shrink: 0;
  margin-top: 2px;
}
.nl-item--info .nl-item__icon mat-icon {
  color: #3b82f6;
}
.nl-item--success .nl-item__icon mat-icon {
  color: #16a34a;
}
.nl-item--warning .nl-item__icon mat-icon {
  color: #f59e0b;
}
.nl-item--error .nl-item__icon mat-icon {
  color: #dc2626;
}
.nl-item__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--nl-muted);
}
.nl-item__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.nl-item__body--link {
  cursor: pointer;
}
.nl-item__top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nl-item__title {
  font-size: 14px;
  font-weight: 500;
  color: var(--nl-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nl-item--unread .nl-item__title {
  font-weight: 700;
}
.nl-item__unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc2626;
  flex-shrink: 0;
}
.nl-item__message {
  margin: 0;
  font-size: 13px;
  color: var(--nl-muted);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.nl-item__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.nl-item__origin {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: var(--nl-muted);
}
.nl-item__origin mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}
.nl-item__date {
  font-size: 11.5px;
  color: var(--nl-muted);
  margin-left: auto;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.nl-type-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.nl-type-badge--informativo {
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
}
.nl-type-badge--exito {
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}
.nl-type-badge--alerta {
  background: rgba(245, 158, 11, 0.1);
  color: #92400e;
}
.nl-type-badge--error {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}
.nl-item__menu {
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.15s;
  color: var(--nl-muted) !important;
}
.nl-item:hover .nl-item__menu {
  opacity: 1;
}
.nl-menu-danger,
.nl-menu-danger mat-icon {
  color: #dc2626 !important;
}
/*# sourceMappingURL=notification-list.component.css.map */
